import rightImg from "images/sectionhero.png";
import rightImg2 from "images/image2.png";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SectionHero3 from "components/SectionHero/SectionHero3";
import SectionHero from "containers/PageAbout/SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import { globalJson } from "global/global_json";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import RentalPolicies from "components/RentalPolicies/RentalPolicies";
import WhyChooseUs from "components/WhyChooseUS/WhyChooseUs";
import WhatSetsUsApart from "components/SetupApart/SetupApart";

function PageHome3() {
  useEffect(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }, []);

  return (
    <>
      <div className="nc-PageHome3 relative overflow-hidden">
        <SectionHero3 className="" />

        <div className="container relative" style={{ padding: "0px" }}>
          <div id="section">
            <div className="container relative py-16">
              <SectionGridFeaturePlaces />
            </div>
            <div className="container py-16 lg:py-28 space-y-16 ">
              <SectionHero
                rightImg={rightImg}
                heading="About Us – LA Exotic Autos"
                btnText=""
                subHeading={globalJson?.about_us_para}
              />
            </div>
            <div className="container py-16">
              <div className="bg-[#F5F5F7] rounded-xl">
                <div className="relative py-16">
                  <SectionClientSay uniqueClassName="PageAbout_" />
                </div>
              </div>
            </div>
            <div className="container py-16 lg:py-28 space-y-16 ">
              <WhyChooseUs />
            </div>
          </div>
        </div>
        <div className="container relative py-16">
          <RentalPolicies />
        </div>
      </div>
    </>
  );
}

export default PageHome3;
